import * as constants from "./constants";
import history from "../../utils/history";
import API from "../../server";
import { SET_NAME_VALUE as SET_NAME_VALUE_CLAIM } from "../../pages/makeclaim/store/constants";
import { SET_NAME_VALUE as SET_NAME_VALUE_CERT } from "../../pages/makecert/store/constants";

export const deleteItem = () => {
  return (dispatch, getState) => {
    let api = getState().getIn(["modal", "modalProps", "api"]),
      action = getState().getIn(["modal", "modalProps", "action"]);
    let httpRequest = API[api.name](...api.config);
    httpRequest
      .then((res) => res.data)
      .then((res) => {
        dispatch(hideModal());
        if (action !== undefined) {
          if (Array.isArray(action)) {
            for (var index in action) {
              dispatch(action[index]);
            }
          } else {
            dispatch(action);
          }
        }
      });
  };
};

export const hideModal = (status) => {
  return (dispatch, getState) => {
    //set issue claim sending email as false
    dispatch({
      type: SET_NAME_VALUE_CLAIM,
      name: "sendingEmail",
      value: false,
    });
    //set issue cert sending email as false
    dispatch({ type: SET_NAME_VALUE_CERT, name: "sendingEmail", value: false });

    let url = getState().getIn(["modal", "modalProps", "url"]),
      type = getState().getIn(["modal", "modalType"]),
      action = getState().getIn(["modal", "modalProps", "action"]);
    dispatch({
      type: constants.HIDE_MODAL,
      status,
    });
    if (status !== "cancel") {
      url && history.push(url);
    }
    type === "confirm" && action && dispatch(action);
  };
};

export const showModal = (modalType, modalProps) => ({
  type: constants.SHOW_MODAL,
  modalType,
  modalProps,
});

export const setModalInfo = (value) => ({
  type: constants.SET_MODAL_INFO,
  value,
});
